import React from 'react';
const painPoints = ['Lavás el auto de un cliente y cuando sale al sol se ven rayones circulares por todos lados', 'Cobrás barato porque no sabés cómo justificar un precio alto y terminás trabajando gratis', 'Llegás a la noche con la espalda rota y el bolsillo vacío sabiendo que podrías haber cobrado el doble', 'Intentaste aprender viendo videos de YouTube pero cada uno dice algo diferente y terminás más confundido', 'Sabés que el detailing es un negocio rentable pero no tenés el método para arrancar y llenar tu agenda', 'Tu potencial está intacto pero sin el conocimiento correcto seguís siendo el que lava autos baratos en el garage'];
export function PainPoints() {
  return <section className="w-full px-4 py-10 text-gray-900 text-base leading-6" style={{
    backgroundColor: '#0d0d0d',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-176">
      <div className="mx-auto max-w-3xl" data-id="element-177">
        {/* Section Title */}
        <p className="text-center text-xs sm:text-sm font-bold tracking-[2px] uppercase text-red-400 mb-2" data-id="element-178">
          ¿Te sentís identificado?
        </p>
        <h2 className="text-center text-2xl sm:text-3xl font-black text-white m-0 mb-6" data-id="element-179">
          Esto le pasa al 90% de los que intentan vivir del detailing
        </h2>

        {/* Pain Points Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-180">
          {painPoints.map((point, i) => <div key={i} className="flex items-start gap-2 bg-white/5 border border-red-500/20 rounded-lg p-3 shadow-sm" data-id="element-181">
              <span className="text-red-400 text-base leading-5 shrink-0" data-id="element-182">
                ✗
              </span>
              <p className="text-xs sm:text-sm text-gray-300 m-0" data-id="element-183">{point}</p>
            </div>)}
        </div>

        {/* Bottom CTA */}
        <p className="text-center text-xl sm:text-2xl font-black text-yellow-400 m-0 mb-6" data-id="element-184">
          ¿Cuántos fines de semana más vas a regalar tu tiempo por monedas?
        </p>

        {/* Divider */}
        <div className="h-px w-full" style={{
        backgroundImage: 'linear-gradient(to right, rgba(255,255,255,0), rgb(234,179,8), rgba(255,255,255,0))'
      }} data-id="element-185" />
      </div>
    </section>;
}